var _rect, _path, _g, _path2, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMenuKickSauber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 600,
    viewBox: "0 0 440 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_774)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_774)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_774",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 687.54L777.16 58.4661H1268.83L300.331 819.329L-23.587 818.53V687.54Z",
    fill: "url(#paint0_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.122 625.24H777.567L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 513.738L368.856 205.431H748.286L-27.857 815.176L-23.587 513.738Z",
    fill: "url(#paint2_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.232 817.891L709.245 434.505H1158.22L667.052 820.367L221.232 817.891Z",
    fill: "url(#paint3_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.019 -12.939L160.942 435.703H592.122L1165.49 -14.736L732.019 -12.939Z",
    fill: "url(#paint4_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.593 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint5_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.8 -10.224Z",
    fill: "url(#paint6_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.623L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint7_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.895 412.49H280.976L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint8_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.857 815.176L298.789 558.56H735.272L405.923 817.299L-27.857 815.176Z",
    fill: "url(#paint9_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 369.04H422.944L-34.447 728.37L-23.587 369.04Z",
    fill: "url(#paint10_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.73 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint11_linear_9_774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.944 -121.136L-153.012 331.34V-118.652L422.944 -121.136Z",
    fill: "url(#paint12_linear_9_774)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#00E701"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9_774)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9_774",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 180,
    width: 229,
    height: 229
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338 180H109V409H338V180Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9_774)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9_774",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 180,
    width: 229,
    height: 229
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338 180H109V409H338V180Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9_774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.974 294.5C335.974 316.746 329.378 338.492 317.019 356.988C304.66 375.485 287.093 389.901 266.541 398.414C245.989 406.927 223.374 409.154 201.556 404.814C179.737 400.474 159.696 389.762 143.966 374.032C128.236 358.302 117.524 338.26 113.184 316.442C108.844 294.624 111.072 272.009 119.585 251.457C128.098 230.904 142.515 213.338 161.012 200.979C179.508 188.62 201.254 182.024 223.5 182.024C238.271 182.024 252.896 184.934 266.543 190.586C280.189 196.238 292.588 204.523 303.032 214.968C313.477 225.412 321.762 237.811 327.414 251.457C333.066 265.104 335.976 279.729 335.976 294.5",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.5 409.001C197.084 408.985 171.486 399.839 151.042 383.11C130.597 366.382 116.564 343.101 111.319 317.211C106.074 291.321 109.94 264.414 122.262 241.048C134.584 217.682 154.604 199.294 178.931 188.999C206.893 177.28 238.361 177.126 266.436 188.572C294.512 200.018 316.903 222.129 328.701 250.058C340.5 277.986 340.743 309.454 329.377 337.562C318.011 365.669 295.964 388.123 268.069 400.001C253.97 405.969 238.811 409.03 223.5 409.001ZM223.5 184.05C201.655 184.05 180.3 190.527 162.136 202.664C143.972 214.8 129.815 232.05 121.456 252.232C113.096 272.415 110.908 294.623 115.17 316.048C119.431 337.474 129.951 357.155 145.398 372.602C160.844 388.049 180.525 398.568 201.95 402.83C223.376 407.092 245.584 404.905 265.766 396.545C285.949 388.185 303.199 374.028 315.336 355.865C327.472 337.701 333.95 316.346 333.95 294.501C333.917 265.218 322.27 237.144 301.564 216.437C280.857 195.731 252.783 184.083 223.5 184.05Z",
    fill: "#00E701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.959 353.457C181.542 353.435 181.124 353.495 180.73 353.634C180.336 353.773 179.973 353.988 179.663 354.268C179.394 354.513 179.18 354.811 179.035 355.144C178.89 355.477 178.816 355.837 178.82 356.201C178.793 356.494 178.826 356.791 178.917 357.072C179.008 357.352 179.155 357.612 179.349 357.834C180.245 358.485 181.223 359.014 182.257 359.408C183.508 359.874 184.625 360.639 185.512 361.636C186.161 362.653 186.468 363.852 186.388 365.056C186.455 366.125 186.283 367.195 185.886 368.19C185.489 369.184 184.876 370.078 184.091 370.807C182.348 372.226 180.14 372.945 177.896 372.826C176.797 372.818 175.701 372.707 174.623 372.493C173.718 372.333 172.824 372.113 171.948 371.833L171.022 371.469L171.782 368.197C173.715 368.577 175.677 368.798 177.647 368.856C178.741 368.941 179.833 368.682 180.772 368.114C181.126 367.802 181.401 367.41 181.573 366.971C181.746 366.531 181.811 366.057 181.762 365.587C181.78 365.314 181.737 365.041 181.638 364.787C181.538 364.532 181.383 364.303 181.184 364.115C180.305 363.496 179.356 362.981 178.358 362.579C177.129 362.091 176.03 361.321 175.152 360.331C174.459 359.336 174.122 358.137 174.194 356.928C174.162 355.95 174.33 354.977 174.688 354.067C175.047 353.157 175.587 352.33 176.277 351.637C177.012 350.931 177.884 350.382 178.839 350.025C179.793 349.667 180.811 349.508 181.829 349.556C182.943 349.562 184.054 349.668 185.149 349.872C186.048 350.021 186.937 350.225 187.81 350.484L188.736 350.813L187.91 354.051C185.944 353.699 183.953 353.501 181.956 353.457",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.341 372.425L195.454 349.952H203.321L202.627 372.425H198.065L198.197 368.524H191.652L189.901 372.425H185.341ZM198.136 353.922L193.377 364.563H198.365L198.823 353.922H198.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.692 364.793C209.506 365.534 209.405 366.294 209.394 367.059C209.366 367.333 209.414 367.609 209.534 367.857C209.653 368.105 209.84 368.315 210.071 368.464C210.821 368.784 211.637 368.92 212.451 368.859C212.917 368.893 213.386 368.831 213.827 368.675C214.268 368.519 214.672 368.272 215.012 367.952C215.727 367.033 216.194 365.945 216.367 364.793L219.802 349.957H224.363L220.928 364.793C220.554 367.113 219.462 369.258 217.806 370.925C216.198 372.25 214.153 372.928 212.072 372.827C207.268 372.827 204.866 371.13 204.866 367.735C204.877 366.502 205.021 365.274 205.296 364.071L208.568 349.959H213.13L209.692 364.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.224 349.957C239.145 349.957 241.106 351.576 241.107 354.815C241.158 356.059 240.835 357.289 240.182 358.349C239.452 359.381 238.504 360.241 237.406 360.868C238.127 361.239 238.724 361.813 239.124 362.519C239.432 363.227 239.578 363.995 239.553 364.767C239.58 365.792 239.389 366.811 238.993 367.757C238.597 368.703 238.005 369.554 237.256 370.254C235.437 371.808 233.083 372.588 230.696 372.43H222.234L227.423 349.957H235.224ZM232.712 363.01H228.98L227.691 368.528H231.584C232.032 368.546 232.478 368.464 232.891 368.287C233.303 368.11 233.67 367.843 233.965 367.505C234.579 366.764 234.896 365.822 234.856 364.861C234.856 363.625 234.14 363.011 232.708 363.011M234.493 353.851H231.089L229.83 359.207H233.234C233.661 359.215 234.085 359.132 234.478 358.964C234.871 358.796 235.224 358.546 235.513 358.232C236.14 357.555 236.473 356.657 236.438 355.736C236.471 355.475 236.443 355.21 236.356 354.962C236.268 354.714 236.125 354.49 235.936 354.307C235.747 354.125 235.518 353.988 235.268 353.909C235.017 353.83 234.752 353.81 234.492 353.851",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.188 372.425L245.341 349.952H258.528L257.603 353.919H249.016L247.795 359.206H254.603L253.678 363.173H246.901L245.684 368.464H254.311L253.418 372.43L240.188 372.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.387 349.957C269.263 349.802 271.132 350.336 272.642 351.46C273.247 352.083 273.71 352.829 274.001 353.648C274.292 354.466 274.403 355.337 274.328 356.202C274.396 358.108 273.902 359.993 272.907 361.62C272.06 362.991 270.798 364.057 269.305 364.662L271.121 372.429H266.561L265.073 365.291H261.934L260.281 372.429H255.719L260.908 349.956L267.387 349.957ZM268.594 359.969C269.273 359.064 269.639 357.962 269.634 356.83C269.722 356.006 269.524 355.177 269.073 354.482C268.811 354.247 268.502 354.07 268.167 353.962C267.831 353.854 267.477 353.817 267.127 353.853H264.577L262.824 361.39H265.767C266.319 361.406 266.866 361.285 267.36 361.037C267.853 360.789 268.277 360.421 268.592 359.968",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.762 219.568H210.969V245.039H223.705V232.304H236.439V219.568H274.647V257.775H261.911V270.511H249.176V283.247H261.911V295.985H274.647V334.191H236.439V321.453H223.704V308.717H210.968V334.189H172.762V219.568Z",
    fill: "#00E701"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_774",
    x1: 900.323,
    y1: 136.714,
    x2: 220.425,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_774",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.393,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_774",
    x1: 64.8378,
    y1: 608.483,
    x2: 513.999,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_774",
    x1: 360.898,
    y1: 964.812,
    x2: 866.563,
    y2: 444.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_774",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_774",
    x1: 200.656,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9_774",
    x1: -97.0263,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9_774",
    x1: -214.997,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9_774",
    x1: 20.1718,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9_774",
    x1: 560.964,
    y1: 452.869,
    x2: 185.719,
    y2: 876.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9_774",
    x1: -34.4468,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9_774",
    x1: -52.7464,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9_774",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3138,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 229,
    fill: "white",
    transform: "translate(109 180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuKickSauber);
export default __webpack_public_path__ + "static/media/team_menu_kick_sauber.00fec8fba7e4f1137674ea66cb50a87d.svg";
export { ForwardRef as ReactComponent };